import React from 'react';

export const ChevronIcon = React.memo(() => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1148_428)">
      <path d="M1.58691 12C1.58691 6.20101 6.28792 1.5 12.0869 1.5C17.8859 1.5 22.5869 6.20101 22.5869 12C22.5869 17.799 17.8859 22.5 12.0869 22.5C6.28792 22.5 1.58691 17.799 1.58691 12ZM12.0869 0C5.4595 0 0.0869141 5.37258 0.0869141 12C0.0869141 18.6274 5.4595 24 12.0869 24C18.7143 24 24.0869 18.6274 24.0869 12C24.0869 5.37258 18.7143 0 12.0869 0ZM7.11724 9.21967C6.82435 8.92678 6.34948 8.92678 6.05658 9.21967C5.76369 9.51256 5.76369 9.98744 6.05658 10.2803L11.5566 15.7803C11.8495 16.0732 12.3244 16.0732 12.6172 15.7803L18.1172 10.2803C18.4101 9.98744 18.4101 9.51256 18.1172 9.21967C17.8244 8.92678 17.3495 8.92678 17.0566 9.21967L12.0869 14.1893L7.11724 9.21967Z" fill="#424242" />
    </g>
    <defs>
      <clipPath id="clip0_1148_428">
        <rect width="24" height="24" fill="white" transform="translate(0.0869141)" />
      </clipPath>
    </defs>
  </svg>
));

